var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.745 8 2.079-2.079a.484.484 0 1 0-.685-.684L8.06 7.315 5.982 5.237a.484.484 0 1 0-.685.684l2.079 2.08-2.079 2.078a.484.484 0 1 0 .685.684L8.06 8.685l2.08 2.078a.483.483 0 0 0 .684 0 .484.484 0 0 0 0-.684L8.745 8z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitWhite);
export default __webpack_public_path__ + "static/media/exit_white.f7e3269920aaed28d45e34884f1ec314.svg";
export { ForwardRef as ReactComponent };